const localState = {
    administrators: null,
    orderBy: '',
    sortBy: '',
    params: {},
    show: false,
    administrator: {
        role: 'super-admin',
        offices: [],
    },
    isUpdate: false,
    deleteId: null,
    deleteModal: false,
}

const mutations = {
    setAdmintrators: (state, v) => {
        state.administrators = v
    },
    setAdmintrator: (state, v) => {
        state.administrator = v
    },
    toggleModal: (state) => {
        state.show = !state.show
        state.isUpdate = false

        state.administrator = {
            role: 'super-admin',
        }
    },
    setIsUpdate: (state, v) => {
        state.isUpdate = v
    },
    toggleDeleteModal: (state) => {
        state.deleteModal = !state.deleteModal
    },
    openDeleteModal: (state, v) => {
        state.deleteId = v
        state.deleteModal = !state.deleteModal
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        try {
            const response = await this.$api.administrators.fetch()
            commit(
                'setAdmintrators',
                response.data.data !== undefined ? response.data.data : [],
            )
        } catch (err) {
            console.log(err)
        }
    },

    async create({
        commit,
        state,
    }) {
        try {
            const response = await this.$api.administrators.create(state.administrator)
            if (response.status !== 201) return

            this.dispatch('administrators/fetch')
            this.dispatch('getAdminData')
            commit('toggleModal')
        } catch (err) {
            console.log(err)
        }
    },

    async update({
        commit,
        state,
    }, id) {
        try {
            const response = await this.$api.administrators.update(id, state.administrator)
            if (response.status !== 200) return

            this.dispatch('administrators/fetch')
            this.dispatch('getAdminData')
            commit('toggleModal')
        } catch (err) {
            console.log(err)
        }
    },

    async fetchById({
        commit,
    }, id) {
        try {
            const response = await this.$api.administrators.fetchById(id)
            const {
                data,
            } = response.data

            commit('toggleModal')

            const partner = {
                id: data.id,
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                phone: data.phone,
                role: data.role.slug,
                offices: data.offices,
            }

            if (data.partner !== null) {
                partner.partner_id = data.partner.id
            }

            commit('setAdmintrator', partner)
            commit('setIsUpdate', true)
        } catch (err) {
            console.log(err)
        }
    },

    async remove({
        commit,
        state,
    }) {
        try {
            const id = state.deleteId
            const response = await this.$api.administrators.remove(id)

            if (response.status === 204) {
                commit('toggleDeleteModal')
                this.dispatch('administrators/fetch')
            }
        } catch (err) {
            console.log(err)
        }
    },
}

const getters = {
    administratorsGetters: (state) => state.administrators,
    administratorGetters: (state) => state.administrator,
    showGetters: (state) => state.show,
    isUpdateGetters: (state) => state.isUpdate,
    deleteIdGerrers: (state) => state.deleteId,
    deleteModalGetters: (state) => state.deleteModal,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
